import React from "react";
import { motion } from "framer-motion";

const item = {
  hidden: {
    x: -50,
    opacity: 0,
    transition: {
      ease: "easeOut",
    },
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      ease: "easeOut",
    },
  },
  mobileHidden: {
    x: -50,
    opacity: 0,
    transition: {
      ease: "easeOut",
    },
  },
  mobileVisible: {
    x: 0,
    opacity: 1,
    transition: {
      ease: "easeOut",
    },
  },
};

const svg = {
  hidden: {
    x: -40,
    transition: {
      ease: "easeOut",
    },
  },
  visible: {
    x: 0,
    transition: {
      ease: "easeOut",
    },
  },
};
function Logo() {
  return (
    <motion.svg
      className="header__logo-svg"
      variants={svg}
      width="158"
      height="37"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 158 37"
    >
      <g fill="none" fillRule="evenodd">
        <motion.path
          className="header__logo-svg__name"
          variants={item}
          d="M72.6,16V28A4.8,4.8,0,0,1,68,23.1V15.6h0a3.6,3.6,0,0,0-1.1-2,3.1,3.1,0,0,0-2.1-.7,3.5,3.5,0,0,0-2.2.8,3.5,3.5,0,0,0-1,2.2v9.9a2.3,2.3,0,0,1-2.3,2.3A2.4,2.4,0,0,1,57,25.8V16a2.9,2.9,0,0,0-.9-2.2,2.9,2.9,0,0,0-2.3-1,3.2,3.2,0,0,0-2.1.8,3.3,3.3,0,0,0-1.1,1.9V25.7A2.3,2.3,0,0,1,48.3,28,2.3,2.3,0,0,1,46,25.7V16a7.3,7.3,0,0,1,.6-3,8.1,8.1,0,0,1,1.7-2.4,7.4,7.4,0,0,1,2.5-1.7,7.3,7.3,0,0,1,3-.6,7.2,7.2,0,0,1,2.9.6,9.7,9.7,0,0,1,2.4,1.5l.2.2.2-.2a9.7,9.7,0,0,1,2.4-1.5,6.8,6.8,0,0,1,2.9-.6,7.7,7.7,0,0,1,3,.6,10.1,10.1,0,0,1,2.5,1.7A8.1,8.1,0,0,1,72,13v.2A8.7,8.7,0,0,1,72.6,16Z M94.3,14.3h0a11.1,11.1,0,0,0-2.1-3.2,10.4,10.4,0,0,0-7-2.9,10.1,10.1,0,0,0-3.9.8,9.5,9.5,0,0,0-3.1,2.1A14,14,0,0,0,76,14.3a9.9,9.9,0,0,0-.7,3.8A10,10,0,0,0,76,22a8.7,8.7,0,0,0,2.2,3.1,9.7,9.7,0,0,0,3.1,2.2,10,10,0,0,0,3.9.7,9.9,9.9,0,0,0,3.8-.7,11.8,11.8,0,0,0,3.2-2.1A9.9,9.9,0,0,0,94.3,22a9.2,9.2,0,0,0,.8-3.8A10.1,10.1,0,0,0,94.3,14.3Zm-4.3,6h0A9.9,9.9,0,0,1,88.9,22a6.2,6.2,0,0,1-1.7,1.1,4.5,4.5,0,0,1-2,.4,4.6,4.6,0,0,1-2.1-.4A3.9,3.9,0,0,1,81.4,22a5,5,0,0,1-1.1-1.7,4.6,4.6,0,0,1-.5-2,5,5,0,0,1,.5-2.1,5.9,5.9,0,0,1,1-1.7L83,13.4a5.7,5.7,0,0,1,4.2,0,9.1,9.1,0,0,1,1.6,1.1A6.6,6.6,0,0,1,90,16.2a5.2,5.2,0,0,1,.4,2.1A5.1,5.1,0,0,1,90,20.3Z M112.8,7.2V9.8l-.4-.2-2.3-1a10.9,10.9,0,0,0-2.6-.3,8.1,8.1,0,0,0-3.8.8,11.6,11.6,0,0,0-3.2,2,9.9,9.9,0,0,0-2.1,3.2,10,10,0,0,0-.8,3.8,10.1,10.1,0,0,0,.8,3.9,8.5,8.5,0,0,0,2.1,3.1,10.2,10.2,0,0,0,3.2,2.2,9.9,9.9,0,0,0,3.8.7,10,10,0,0,0,3.9-.7,9.7,9.7,0,0,0,3.1-2.2,10.2,10.2,0,0,0,2.2-3.1,10,10,0,0,0,.7-3.9V2.3A4.9,4.9,0,0,0,112.8,7.2Zm-.4,13.1h0a6.2,6.2,0,0,1-1.1,1.7,5.7,5.7,0,0,1-1.6,1.1,5.2,5.2,0,0,1-2.1.4,4.9,4.9,0,0,1-2.1-.4,4.5,4.5,0,0,1-1.7-1.1,5,5,0,0,1-1.1-1.7,4.5,4.5,0,0,1-.4-2,4.9,4.9,0,0,1,.4-2.1,4.5,4.5,0,0,1,1.1-1.7l1.7-1.1a5.7,5.7,0,0,1,4.2,0,9.1,9.1,0,0,1,1.6,1.1,6.6,6.6,0,0,1,1.2,1.7,5.2,5.2,0,0,1,.4,2.1A3.9,3.9,0,0,1,112.4,20.3Z M139.1,10.5v8.7a8.9,8.9,0,0,1-8.9,8.8h-.1a8.9,8.9,0,0,1-8.8-9V8.3a4.8,4.8,0,0,1,4.5,4.8v6a4.5,4.5,0,0,0,1.4,3.2,4.2,4.2,0,0,0,7.2-3V10.5a2.3,2.3,0,0,1,2.3-2.3A2.5,2.5,0,0,1,139.1,10.5Z M156.8,22a6.1,6.1,0,0,1-.4,2.4,6.4,6.4,0,0,1-1.3,1.9,8,8,0,0,1-1.9,1.3,6.4,6.4,0,0,1-2.4.5h-6a2.2,2.2,0,0,1-2.1-2.2,2.1,2.1,0,0,1,2.1-2.1h6a.8.8,0,0,0,.7-.2l.6-.3c.1-.2.3-.4.3-.6a1.4,1.4,0,0,0,.2-.7,1.9,1.9,0,0,0-.2-.7h0l-.3-.5-.7-.4-.6-.2h-2.9a5.9,5.9,0,0,1-2.3-.5,6.4,6.4,0,0,1-1.9-1.3,5.9,5.9,0,0,1-1.3-1.9,6.9,6.9,0,0,1-.5-2.4,5.9,5.9,0,0,1,.5-2.3,4.3,4.3,0,0,1,1.3-1.9,5.9,5.9,0,0,1,1.9-1.3h0a5.9,5.9,0,0,1,2.3-.5H155V9.4h0a3.2,3.2,0,0,1-3.1,3.1h-4.6l-.6.4a1.5,1.5,0,0,0-.4.6,1.5,1.5,0,0,0-.1.7,1.3,1.3,0,0,0,.1.6h0a1,1,0,0,0,.4.5.9.9,0,0,0,.6.4l.7.2h2.8a5.9,5.9,0,0,1,2.3.5,5,5,0,0,1,1.9,1.3,5,5,0,0,1,1.3,1.9A5.9,5.9,0,0,1,156.8,22Z"
          fill="#002B41"
        />

        <path
          className="header__logo-svg__circle"
          d="M36.5,18.3A18.1,18.1,0,0,1,18.3,36.5,18.3,18.3,0,1,1,36.5,18.3Z"
          fill="#50B848"
        />
        <path
          className="header__logo-svg__lines"
          d="M26.6,12.8v11A2.2,2.2,0,0,1,24.4,26a2.2,2.2,0,0,1-2.3-2.2v-11a2.3,2.3,0,1,1,4.5,0Z M20.5,12.8v7.6a2.2,2.2,0,0,1-2.2,2.2,2.3,2.3,0,0,1-2.4-2.2V12.8a2.4,2.4,0,0,1,2.4-2.4A2.4,2.4,0,0,1,20.5,12.8Z M14.4,12.8v11A2.2,2.2,0,0,1,12.1,26a2.3,2.3,0,0,1-2.3-2.2v-11a2.3,2.3,0,0,1,2.3-2.4A2.4,2.4,0,0,1,14.4,12.8Z"
          fill="#FFF"
        />
      </g>
    </motion.svg>
  );
}

export default Logo;
